import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { LoadState_zip, LoadState$2, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { record_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector, useDispatch } from "../../Redux/Store.js";
import * as react from "react";
import { tryFind, cons, ofArray, forAll, empty, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { stripHtmlTags, strToOpt, optToStr } from "../../Utils.js";
import { map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { ContractEndUserDTO, saveContractEndUser, deleteContractEndUser, loadContractEndUser as loadContractEndUser_1 } from "./Api.js";
import { loadCountriesThunk } from "../../Api/Misc.js";
import { dotsLoading } from "../../ViewUtils.js";
import { error } from "../../Components/Message/Message.js";
import { printf, toText, isNullOrEmpty, isNullOrWhiteSpace } from "../../fable_modules/fable-library.3.7.20/String.js";
import { Result_Bind, FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { InputType, lengthLTE } from "../../Validation/Common.js";
import { SelectOption, ValueProp, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { renderEditableSideTable } from "../../Components/Table/Table.js";
import { loadContractsThunk } from "../../Api/Contract.js";
import { MessageType, renderAsModal } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";

export class EndUserTableProps extends Record {
    constructor(GlobalDependencies, ContractNr) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.ContractNr = (ContractNr | 0);
    }
}

export function EndUserTableProps$reflection() {
    return record_type("Containers.EndUserTable.View.EndUserTableProps", [], EndUserTableProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["ContractNr", int32_type]]);
}

export const renderEndUserTable = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_1, inputRecord, children_3, inputRecord_1, children_5, inputRecord_2, children_7, inputRecord_3, inputRecord_4, children_11, inputRecord_5, children_13, inputRecord_6, children_15, inputRecord_7, children_17, inputRecord_8, OptionValues, children_19, arg_14, arg_13, inputRecord_9, children_22;
    const reduxDispatch = useDispatch();
    const countriesLoadState = useSelector((state) => state.Model.Countries);
    const translationsLoadState = useSelector((state_1) => state_1.Model.Translations);
    const invoiceeDetailsLoadState = useSelector((state_2) => state_2.Invoicee.InvoiceeDetails);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const errorMessageState = react.useState(void 0);
    const isEditingState = react.useState(false);
    const contractEndUserState = react.useState(new LoadState$2(0));
    const countries_1 = react.useMemo(() => {
        if (countriesLoadState.tag === 2) {
            return map((country) => [country.Code.ThreeLetter, country.DisplayName], countriesLoadState.fields[0]);
        }
        else {
            return empty();
        }
    }, [countriesLoadState]);
    const firstNameState = react.useState("");
    const middleNameState = react.useState("");
    const lastNameState = react.useState("");
    const alternateDisplayNameState = react.useState("");
    const postalAttentionState = react.useState("");
    const postalStreetAddressState = react.useState("");
    const postalCityState = react.useState("");
    const postalCodeState = react.useState("");
    const postalCountryCodeState = react.useState("");
    const orgNrState = react.useState("");
    const setFormFields = (contractEndUserOpt) => {
        if (contractEndUserOpt == null) {
            firstNameState[1]("");
            middleNameState[1]("");
            lastNameState[1]("");
            alternateDisplayNameState[1]("");
            postalAttentionState[1]("");
            postalStreetAddressState[1]("");
            postalCityState[1]("");
            postalCodeState[1]("");
            postalCountryCodeState[1]("");
            orgNrState[1]("");
        }
        else {
            const contractEndUser = contractEndUserOpt;
            firstNameState[1](optToStr(contractEndUser.FirstName));
            middleNameState[1](optToStr(contractEndUser.MiddleName));
            lastNameState[1](optToStr(contractEndUser.LastName));
            alternateDisplayNameState[1](optToStr(contractEndUser.AlternateDisplayName));
            postalAttentionState[1](optToStr(contractEndUser.PostalAttention));
            postalStreetAddressState[1](optToStr(contractEndUser.PostalStreetAddress));
            postalCityState[1](optToStr(contractEndUser.PostalCity));
            postalCodeState[1](optToStr(contractEndUser.PostalCode));
            postalCountryCodeState[1](defaultArg(contractEndUser.PostalCountryCode, props.GlobalDependencies.CountryCode.ThreeLetter));
            orgNrState[1](optToStr(contractEndUser.OrganizationNr));
        }
    };
    const resetStates = () => {
        const matchValue = contractEndUserState[0];
        if (matchValue.tag === 2) {
            setFormFields(matchValue.fields[0]);
        }
        else {
            firstNameState[1]("");
            middleNameState[1]("");
            lastNameState[1]("");
            alternateDisplayNameState[1]("");
            postalAttentionState[1]("");
            postalStreetAddressState[1]("");
            postalCityState[1]("");
            postalCodeState[1]("");
            postalCountryCodeState[1]("");
            orgNrState[1]("");
        }
        isEditingState[1](false);
        errorMessageState[1](void 0);
    };
    const loadContractEndUser = () => {
        contractEndUserState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(loadContractEndUser_1(props.GlobalDependencies.ClientNr, props.ContractNr), (_arg_9) => {
            const result = _arg_9;
            let arg;
            if (result.tag === 1) {
                arg = (new LoadState$2(3, result.fields[0]));
            }
            else {
                const contractEndUserOpt_2 = result.fields[0];
                setFormFields(contractEndUserOpt_2);
                arg = (new LoadState$2(2, contractEndUserOpt_2));
            }
            contractEndUserState[1](arg);
            return singleton.Zero();
        })));
    };
    react.useEffect(() => {
        loadContractEndUser();
        switch (countriesLoadState.tag) {
            case 3: {
                reduxDispatch(loadCountriesThunk());
                break;
            }
            case 1:
            case 2: {
                break;
            }
            default: {
                reduxDispatch(loadCountriesThunk());
            }
        }
    }, [props.GlobalDependencies, props.ContractNr]);
    let tableHtml;
    const matchValue_1 = LoadState_zip(contractEndUserState[0], countriesLoadState);
    switch (matchValue_1.tag) {
        case 1: {
            tableHtml = dotsLoading;
            break;
        }
        case 3: {
            tableHtml = error(matchValue_1.fields[0].split(""));
            break;
        }
        case 2: {
            const allFieldsAreEmpty = forAll(isNullOrWhiteSpace, ofArray([firstNameState[0], middleNameState[0], lastNameState[0], alternateDisplayNameState[0], postalAttentionState[0], postalStreetAddressState[0], postalCodeState[0], postalCityState[0], orgNrState[0]]));
            let hasEitherAlternateDisplayNameOrNormalNames;
            const concattedNormalNames = (firstNameState[0]) + (lastNameState[0]);
            const matchValue_2 = [isNullOrEmpty(alternateDisplayNameState[0]), isNullOrEmpty(concattedNormalNames)];
            let pattern_matching_result;
            if (matchValue_2[0]) {
                if (matchValue_2[1]) {
                    pattern_matching_result = 0;
                }
                else {
                    pattern_matching_result = 0;
                }
            }
            else if (matchValue_2[1]) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 1;
            }
            switch (pattern_matching_result) {
                case 0: {
                    hasEitherAlternateDisplayNameOrNormalNames = true;
                    break;
                }
                case 1: {
                    hasEitherAlternateDisplayNameOrNormalNames = false;
                    break;
                }
            }
            const eitherAlternateDisplayNameOrNormalNamesResult = (str) => {
                if (hasEitherAlternateDisplayNameOrNormalNames) {
                    return new FSharpResult$2(0, str);
                }
                else {
                    return new FSharpResult$2(1, getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUser.AlternateDisplayNameError"));
                }
            };
            const firstNameRow = [ofArray([(children_1 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUser.FirstName")], react.createElement("span", {
                ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.EndUser.FirstName",
            }, ...children_1)), (isEditingState[0]) ? render_1()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(firstNameState[0], inputRecord.Type, inputRecord.Classes, (e) => {
                firstNameState[1](Browser_Types_Event__Event_get_Value(e));
            }, inputRecord.Disabled, inputRecord.LabelText, "end-user-firstname-input", (str_2) => Result_Bind((str_3) => lengthLTE(getTranslation, 15, new InputType(1), str_3), eitherAlternateDisplayNameOrNormalNamesResult(str_2)), inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))) : (firstNameState[0])]), "end-user-firstname"];
            const middleNameRow = [ofArray([(children_3 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUser.MiddleName")], react.createElement("span", {
                ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.EndUser.MiddleName",
            }, ...children_3)), (isEditingState[0]) ? render_1()((inputRecord_1 = TextProps$1_GetDefault(), new TextProps$1(middleNameState[0], inputRecord_1.Type, inputRecord_1.Classes, (e_1) => {
                middleNameState[1](Browser_Types_Event__Event_get_Value(e_1));
            }, inputRecord_1.Disabled, inputRecord_1.LabelText, "end-user-middlename-input", (str_4) => lengthLTE(getTranslation, 15, new InputType(1), str_4), inputRecord_1.DynamicWidth, inputRecord_1.HTMLProps, inputRecord_1.OnBlur, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name))) : (middleNameState[0])]), "end-user-middlename"];
            const lastNameRow = [ofArray([(children_5 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUser.LastName")], react.createElement("span", {
                ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.EndUser.LastName",
            }, ...children_5)), (isEditingState[0]) ? render_1()((inputRecord_2 = TextProps$1_GetDefault(), new TextProps$1(lastNameState[0], inputRecord_2.Type, inputRecord_2.Classes, (e_2) => {
                lastNameState[1](Browser_Types_Event__Event_get_Value(e_2));
            }, inputRecord_2.Disabled, inputRecord_2.LabelText, "end-user-lastname-input", (str_6) => Result_Bind((str_7) => lengthLTE(getTranslation, 15, new InputType(1), str_7), eitherAlternateDisplayNameOrNormalNamesResult(str_6)), inputRecord_2.DynamicWidth, inputRecord_2.HTMLProps, inputRecord_2.OnBlur, inputRecord_2.OnFocus, inputRecord_2.AutoComplete, inputRecord_2.Name))) : (lastNameState[0])]), "end-user-lastname"];
            const alternateDisplayNameRow = [ofArray([(children_7 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUser.AlternateDisplayName")], react.createElement("span", {}, ...children_7)), (isEditingState[0]) ? render_1()((inputRecord_3 = TextProps$1_GetDefault(), new TextProps$1(alternateDisplayNameState[0], inputRecord_3.Type, inputRecord_3.Classes, (e_3) => {
                alternateDisplayNameState[1](Browser_Types_Event__Event_get_Value(e_3));
            }, inputRecord_3.Disabled, inputRecord_3.LabelText, "end-user-alternate-display-name-input", (str_8) => Result_Bind((str_9) => lengthLTE(getTranslation, 256, new InputType(2), str_9), eitherAlternateDisplayNameOrNormalNamesResult(str_8)), inputRecord_3.DynamicWidth, inputRecord_3.HTMLProps, inputRecord_3.OnBlur, inputRecord_3.OnFocus, inputRecord_3.AutoComplete, inputRecord_3.Name))) : (alternateDisplayNameState[0])]), "end-user-alternate-display-name"];
            const postalAttentionRow = [ofArray([react.createElement("span", {}, "C/O"), (isEditingState[0]) ? render_1()((inputRecord_4 = TextProps$1_GetDefault(), new TextProps$1(postalAttentionState[0], inputRecord_4.Type, inputRecord_4.Classes, (e_4) => {
                postalAttentionState[1](Browser_Types_Event__Event_get_Value(e_4));
            }, inputRecord_4.Disabled, inputRecord_4.LabelText, "end-user-postal-attention-input", (str_10) => lengthLTE(getTranslation, 40, new InputType(1), str_10), inputRecord_4.DynamicWidth, inputRecord_4.HTMLProps, inputRecord_4.OnBlur, inputRecord_4.OnFocus, inputRecord_4.AutoComplete, inputRecord_4.Name))) : (postalAttentionState[0])]), "end-user-postal-attention"];
            const postalStreetAddress = [ofArray([(children_11 = [getTranslation("Common.StreetAddress")], react.createElement("span", {
                ["data-translation"]: "Common.StreetAddress",
            }, ...children_11)), (isEditingState[0]) ? render_1()((inputRecord_5 = TextProps$1_GetDefault(), new TextProps$1(postalStreetAddressState[0], inputRecord_5.Type, inputRecord_5.Classes, (e_5) => {
                postalStreetAddressState[1](Browser_Types_Event__Event_get_Value(e_5));
            }, inputRecord_5.Disabled, inputRecord_5.LabelText, "end-user-postal-street-address-input", (str_11) => lengthLTE(getTranslation, 40, new InputType(1), str_11), inputRecord_5.DynamicWidth, inputRecord_5.HTMLProps, inputRecord_5.OnBlur, inputRecord_5.OnFocus, inputRecord_5.AutoComplete, inputRecord_5.Name))) : (postalStreetAddressState[0])]), "end-user-postal-street-address"];
            const postalCodeRow = [ofArray([(children_13 = [getTranslation("Common.PostalCode")], react.createElement("span", {
                ["data-translation"]: "Common.PostalCode",
            }, ...children_13)), (isEditingState[0]) ? render_1()((inputRecord_6 = TextProps$1_GetDefault(), new TextProps$1(postalCodeState[0], inputRecord_6.Type, inputRecord_6.Classes, (e_6) => {
                postalCodeState[1](Browser_Types_Event__Event_get_Value(e_6));
            }, inputRecord_6.Disabled, inputRecord_6.LabelText, "end-user-postal-code-input", (str_12) => lengthLTE(getTranslation, 8, new InputType(1), str_12), inputRecord_6.DynamicWidth, inputRecord_6.HTMLProps, inputRecord_6.OnBlur, inputRecord_6.OnFocus, inputRecord_6.AutoComplete, inputRecord_6.Name))) : (postalCodeState[0])]), "end-user-postal-code"];
            const postalCityRow = [ofArray([(children_15 = [getTranslation("Common.PostalCity")], react.createElement("span", {
                ["data-translation"]: "Common.PostalCity",
            }, ...children_15)), (isEditingState[0]) ? render_1()((inputRecord_7 = TextProps$1_GetDefault(), new TextProps$1(postalCityState[0], inputRecord_7.Type, inputRecord_7.Classes, (e_7) => {
                postalCityState[1](Browser_Types_Event__Event_get_Value(e_7));
            }, inputRecord_7.Disabled, inputRecord_7.LabelText, "end-user-postal-city-input", (str_13) => lengthLTE(getTranslation, 25, new InputType(1), str_13), inputRecord_7.DynamicWidth, inputRecord_7.HTMLProps, inputRecord_7.OnBlur, inputRecord_7.OnFocus, inputRecord_7.AutoComplete, inputRecord_7.Name))) : (postalCityState[0])]), "end-user-postal-city"];
            const postalCountryCodeRow = [ofArray([(children_17 = [getTranslation("Common.Country")], react.createElement("span", {
                ["data-translation"]: "Common.Country",
            }, ...children_17)), (isEditingState[0]) ? selectOption((inputRecord_8 = SelectOption_get_getDefault(), (OptionValues = cons(["", getTranslation("Common.Choose")], countries_1), new SelectOption(new ValueProp(0, postalCountryCodeState[0], (e_8) => {
                postalCountryCodeState[1](Browser_Types_Event__Event_get_Value(e_8));
            }), "end-user-postal-country-code-input", OptionValues, inputRecord_8.Classes, inputRecord_8.LabelText, inputRecord_8.Disabled, inputRecord_8.HTMLProps)))) : defaultArg(map_1((tuple) => tuple[1], tryFind((country_1) => (country_1[0] === (postalCountryCodeState[0])), countries_1)), "")]), "end-user-postal-country-code"];
            const orgNrRow = [ofArray([(children_19 = [(arg_14 = getTranslation("Common.OrgNrShort"), (arg_13 = getTranslation("Common.PersonalNr"), toText(printf("%s/%s"))(arg_13)(arg_14)))], react.createElement("span", {
                ["data-translation"]: "Common.OrgNrLong",
            }, ...children_19)), (isEditingState[0]) ? render_1()((inputRecord_9 = TextProps$1_GetDefault(), new TextProps$1(orgNrState[0], inputRecord_9.Type, inputRecord_9.Classes, (e_9) => {
                orgNrState[1](Browser_Types_Event__Event_get_Value(e_9));
            }, inputRecord_9.Disabled, inputRecord_9.LabelText, "end-user-org-nr-input", (str_14) => lengthLTE(getTranslation, 11, new InputType(2), str_14), inputRecord_9.DynamicWidth, inputRecord_9.HTMLProps, inputRecord_9.OnBlur, inputRecord_9.OnFocus, inputRecord_9.AutoComplete, inputRecord_9.Name))) : (orgNrState[0])]), "end-user-org-nr"];
            tableHtml = renderEditableSideTable(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUser"), ofArray([firstNameRow, middleNameRow, lastNameRow, alternateDisplayNameRow, postalAttentionRow, postalStreetAddress, postalCodeRow, postalCityRow, postalCountryCodeRow, orgNrRow]), isEditingState[0], (_arg_10) => {
                isEditingState[1](true);
            }, (_arg_11) => {
                let a, matchValue_14, FirstName, MiddleName, LastName, PostalAttention, PostalStreetAddress, PostalCode, PostalCity, PostalCountryCode, OrganizationNr;
                const shouldDelete = forAll(isNullOrWhiteSpace, ofArray([firstNameState[0], middleNameState[0], lastNameState[0], alternateDisplayNameState[0], postalAttentionState[0], postalStreetAddressState[0], postalCodeState[0], postalCityState[0], orgNrState[0]]));
                startImmediate((a = (shouldDelete ? deleteContractEndUser(props.GlobalDependencies.ClientNr, props.ContractNr) : ((matchValue_14 = Result_Bind((str_1) => {
                    let arg_4, arg_3, arg_7, arg_6, arg_11, arg_10, arg_9;
                    const matchValue_3 = [isNullOrEmpty(alternateDisplayNameState[0]), isNullOrEmpty(firstNameState[0]), isNullOrEmpty(lastNameState[0])];
                    let pattern_matching_result_1;
                    if (matchValue_3[0]) {
                        if (matchValue_3[1]) {
                            if (matchValue_3[2]) {
                                pattern_matching_result_1 = 2;
                            }
                            else {
                                pattern_matching_result_1 = 1;
                            }
                        }
                        else if (matchValue_3[2]) {
                            pattern_matching_result_1 = 0;
                        }
                        else {
                            pattern_matching_result_1 = 3;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 3;
                    }
                    switch (pattern_matching_result_1) {
                        case 0: {
                            return new FSharpResult$2(1, (arg_4 = getTranslation("Validation.Empty"), (arg_3 = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUser.LastName"), toText(printf("%s: %s"))(arg_3)(arg_4))));
                        }
                        case 1: {
                            return new FSharpResult$2(1, (arg_7 = getTranslation("Validation.Empty"), (arg_6 = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUser.FirstName"), toText(printf("%s: %s"))(arg_6)(arg_7))));
                        }
                        case 2: {
                            if (allFieldsAreEmpty) {
                                return new FSharpResult$2(0, str_1);
                            }
                            else {
                                return new FSharpResult$2(1, (arg_11 = getTranslation("Validation.Empty"), (arg_10 = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUser.LastName"), (arg_9 = getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.EndUser.FirstName"), toText(printf("%s, %s: %s"))(arg_9)(arg_10)(arg_11)))));
                            }
                        }
                        case 3: {
                            return new FSharpResult$2(0, str_1);
                        }
                    }
                }, eitherAlternateDisplayNameOrNormalNamesResult("")), (matchValue_14.tag === 1) ? singleton.Return(new FSharpResult$2(1, matchValue_14.fields[0])) : saveContractEndUser(props.GlobalDependencies.ClientNr, props.ContractNr, (FirstName = strToOpt(firstNameState[0]), (MiddleName = strToOpt(middleNameState[0]), (LastName = strToOpt(lastNameState[0]), (PostalAttention = strToOpt(postalAttentionState[0]), (PostalStreetAddress = strToOpt(postalStreetAddressState[0]), (PostalCode = strToOpt(postalCodeState[0]), (PostalCity = strToOpt(postalCityState[0]), (PostalCountryCode = strToOpt(postalCountryCodeState[0]), (OrganizationNr = strToOpt(orgNrState[0]), new ContractEndUserDTO(FirstName, MiddleName, LastName, strToOpt(alternateDisplayNameState[0]), PostalAttention, PostalStreetAddress, PostalCode, PostalCity, PostalCountryCode, OrganizationNr)))))))))))))), singleton.Delay(() => singleton.Bind(a, (_arg_23) => {
                    let _arg_22, invoiceeDetails;
                    return singleton.Return((_arg_22 = _arg_23, (_arg_22.tag === 1) ? (errorMessageState[1](_arg_22.fields[0])) : ((loadContractEndUser(), ((invoiceeDetailsLoadState.tag === 2) ? ((invoiceeDetailsLoadState.fields[0] != null) ? ((invoiceeDetails = invoiceeDetailsLoadState.fields[0], reduxDispatch(loadContractsThunk(props.GlobalDependencies.ClientNr, invoiceeDetails.InvoiceeNr)))) : (void 0)) : (void 0), resetStates())))));
                }))));
            }, (_arg_24) => {
                resetStates();
            });
            break;
        }
        default: {
            tableHtml = react.createElement(react.Fragment, {});
        }
    }
    let errorMessageHtml;
    const matchValue_15 = errorMessageState[0];
    if (matchValue_15 != null) {
        const errorMsg = matchValue_15;
        errorMessageHtml = renderAsModal("Error", (children_22 = [stripHtmlTags(errorMsg.split(""))], react.createElement("div", {}, ...children_22)), new MessageType(2), getTranslation("Common.Close"), (_arg_25) => {
            errorMessageState[1](void 0);
        });
    }
    else {
        errorMessageHtml = react.createElement(react.Fragment, {});
    }
    return react.createElement("div", {
        id: "end-user-table",
        className: "end-user-table",
    }, errorMessageHtml, tableHtml);
}, void 0, uncurry(2, void 0), void 0, "renderEndUserTable", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\EndUserTable\\View.fs", 552);

